import React from 'react';

import {Group} from '@pb/kit-component-group';

import {SkeletonItem} from './skeleton-item';

type Props = {
    labelWidth?: number,
};

export const CheckboxSkeleton = ({labelWidth}: Props) => (
    <Group gap="s" alignItems="center">
        <SkeletonItem width={14} height={14}/>
        {!!labelWidth && <SkeletonItem width={labelWidth} height={16}/>}
    </Group>
);
